import { render, staticRenderFns } from "./approveDetails.vue?vue&type=template&id=f0539280&scoped=true&"
import script from "./approveDetails.vue?vue&type=script&lang=js&"
export * from "./approveDetails.vue?vue&type=script&lang=js&"
import style0 from "./approveDetails.vue?vue&type=style&index=0&id=f0539280&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0539280",
  null
  
)

export default component.exports